import React from 'react';

import {
    Button, Group, Modal, NumberInput, Text,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { Col, Row } from 'react-bootstrap';

import { TableScreenWithoutUpdate } from '../blocks/table_block';
import {
    API_DOMAIN, ENT_TYPES, STATUSES,
} from '../const';
import { formatDateTime } from '../tools/converters';

export default class PocketsQuasisection extends React.Component {
    columns = [
        {
            Header: 'Тип материала',
            sortable: false,
            accessor: 'type',
            maxWidth: 100,
            headerClassName: 'wordwrap',
        }, {
            Header: 'Название',
            accessor: 'title',
            minWidth: 380,
            Cell: (row) => (
                <div>
                    <a
                        href={`/${row.original.type}/${row.original.slug}/`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {row.original.title}
                    </a>
                </div>
            ),
        }, {
            Header: 'Приоритет',
            sortable: false,
            accessor: 'id',
            maxWidth: 110,
            Cell: (row) => {
                const priority = this.getPriority(row.original);

                return (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button
                            compact
                            variant={priority > 0 ? 'filled' : 'light'}
                            color={priority > 0 ? 'blue' : 'gray'}
                            onClick={() => this.openPriorityModal(row.original)}
                        >
                            {priority > 0 ? priority : '—'}
                        </Button>
                    </div>
                );
            },
        }, {
            Header: 'Статус',
            accessor: 'status',
            maxWidth: 160,
            Cell: (row) => (
                <span>
                    <span
                        style={{
                            color: STATUSES[row.value].color,
                            transition: 'all .3s ease',
                        }}
                    >
                        &#x25cf;
                        &nbsp;
                    </span>
                    {STATUSES[row.value].label}
                </span>
            ),
        }, {
            Header: 'Дата добавления',
            accessor: 'created_at',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Дата изменения',
            accessor: 'modified_at',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Дата публикации',
            accessor: 'date_published',
            Cell: (row) => (formatDateTime(row.value)),
            maxWidth: 170,
        }, {
            Header: 'Просм.',
            accessor: 'views',
            maxWidth: 70,
        },
    ];

    constructor(props) {
        super(props);

        this.tableRef = null;

        this.state = {
            entity_alias: ENT_TYPES[5].id,
            entity: {
                id: '', name: '', slug: '', alt_name: '',
            },
            is_update: false,
            project: props.match.params.project,
            endpoint: `v4/${props.match.params.project}/story/?`,
            modalOpen: false,
            editingStory: null,
            priorityValue: 0,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.project !== this.props.match.params.project) {
            this.setState({
                project: this.props.match.params.project,
                endpoint: `v4/${this.props.match.params.project}/story/?`,
            });
        }
    }

    getPriority = (story) => {
        const pinned = (story.pinned_channels || []).find(
            (pc) => pc.slug === this.props.section,
        );

        return pinned ? pinned.priority : 0;
    };

    openPriorityModal = (story) => {
        this.setState({
            modalOpen: true,
            editingStory: story,
            priorityValue: this.getPriority(story),
        });
    };

    closePriorityModal = () => {
        this.setState({
            modalOpen: false,
            editingStory: null,
            priorityValue: 0,
        });
    };

    savePriority = () => {
        const { editingStory, priorityValue, project } = this.state;
        const { section } = this.props;

        const channels = (editingStory.channels || []).map((ch) => {
            const pinned = (editingStory.pinned_channels || []).find(
                (pc) => pc.slug === ch.slug,
            );

            return {
                slug: ch.slug,
                name: ch.name,
                priority: pinned ? pinned.priority : 0,
            };
        });

        const sectionChannel = channels.find((ch) => ch.slug === section);

        if (sectionChannel) {
            sectionChannel.priority = priorityValue;
        } else if (priorityValue > 0) {
            channels.push({
                slug: section,
                name: section,
                priority: priorityValue,
            });
        }

        const uri = `v4/${project}/story/${editingStory.type}/${editingStory.id}/`;

        fetch(`${API_DOMAIN}${uri}`, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ channels }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw response.json();
                }

                return response.json();
            })
            .then(() => {
                notifications.show({
                    title: 'Приоритет сохранён',
                    message: '',
                    color: 'green',
                });
                this.closePriorityModal();

                if (this.tableRef) {
                    this.tableRef.refreshData();
                }
            })
            .catch((error) => {
                if (error && typeof error.then === 'function') {
                    error.then((e) => {
                        notifications.show({
                            title: 'Ошибка',
                            message: e.detail || JSON.stringify(e),
                            color: 'red',
                        });
                    });
                }
            });
    };

    render() {
        const {
            modalOpen, priorityValue, editingStory, project, endpoint,
        } = this.state;

        const { section } = this.props;

        return (
            <div className="container-fluid">
                <Row>
                    <Col md={12}>
                        <TableScreenWithoutUpdate
                            ref={(el) => { this.tableRef = el; }}
                            key={`${project}-${section}`}
                            columns={this.columns}
                            endpoint={`${endpoint}tag=${section}`}
                            data={this.state}
                        />
                    </Col>
                </Row>

                <Modal
                    opened={modalOpen}
                    onClose={this.closePriorityModal}
                    title="Приоритет материала"
                >
                    {editingStory && (
                        <Text size="sm" mb="md">
                            {editingStory.title}
                        </Text>
                    )}
                    <NumberInput
                        label="Приоритет"
                        description="Чем больше число — тем выше материал в списке. Материалы с 0 не закрепляются."
                        value={priorityValue}
                        onChange={(val) => this.setState({ priorityValue: val || 0 })}
                        min={0}
                    />
                    <Group position="right" mt="md">
                        <Button variant="default" onClick={this.closePriorityModal}>
                            Отмена
                        </Button>
                        <Button onClick={this.savePriority}>
                            Сохранить
                        </Button>
                    </Group>
                </Modal>
            </div>
        );
    }
}
